(function(){
function init(){
var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
function findBuy(){return document.querySelector('product-form button[name=add], form[action*=\"/cart/add\"] [type=submit], .hdt-product-form__buttons button[name=add], button[name=add]');}
function goBuy(){var b=findBuy();if(b){var top=b.getBoundingClientRect().top+window.pageYOffset-110;window.scrollTo({top:top,behavior:reduce?'auto':'smooth'});setTimeout(function(){try{b.focus({preventScroll:true})}catch(_){}}, reduce?0:600);}else{window.scrollTo({top:0,behavior:'smooth'})}}

// anchor nav: smooth scroll + scroll spy
var nav=document.querySelector('.lgxnav');
if(nav){
var links=[].slice.call(nav.querySelectorAll('a[data-target]'));
var navH=nav.offsetHeight||52;
links.forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var id=a.getAttribute('data-target');var t=document.getElementById(id);if(t){var top=t.getBoundingClientRect().top+window.pageYOffset-navH-12;window.scrollTo({top:top,behavior:reduce?'auto':'smooth'})}})});
nav.querySelectorAll('[data-buy]').forEach(function(b){b.addEventListener('click',goBuy)});
var targets=links.map(function(a){return document.getElementById(a.getAttribute('data-target'))}).filter(Boolean);
if('IntersectionObserver' in window&&targets.length){var spy=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){var id=en.target.id;links.forEach(function(a){a.classList.toggle('on',a.getAttribute('data-target')===id)})}})},{rootMargin:'-45% 0px -50% 0px',threshold:0});targets.forEach(function(t){spy.observe(t)})}
}

// desktop sticky buy rail: show after hero leaves, hide near footer buy areas
var rail=document.querySelector('.lgxrail');
if(rail){
rail.querySelectorAll('[data-buy]').forEach(function(b){b.addEventListener('click',goBuy)});
var hero=document.querySelector('.lgx-herosec')||document.querySelector('.lgx-hero');
if(hero&&'IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(en){rail.classList.toggle('show',!en.isIntersecting&&en.boundingClientRect.top<0)})},{threshold:0});io.observe(hero)}else{rail.classList.add('show')}
}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
